export const FETCH_LIST = "master/FETCH_LIST";
export const FETCH_LIST_COMPLETED = "master/FETCH_LIST_COMPLETED";
export const FETCH_LIST_FAILED = "master/FETCH_LIST_FAILED";

export const SEND_EMAIL = "master/SEND_EMAIL";
export const SEND_EMAIL_COMPLETED = "master/SEND_EMAIL_COMPLETED";
export const SEND_EMAIL_FAILED = "master/SEND_EMAIL_FAILED";